function dotObject(obj: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {};

    for (const path in obj) {
        const keys = path.split('.');
        let current = result;

        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];

            current[key] = current[key] ?? {};

            current = current[key];
        }

        current[keys[keys.length - 1]] = obj[path];
    }

    return result;
}

// ----------------------------------------------------------------------------

export default dotObject;
